import React from "react";
import { Tooltip } from "antd";
import RecurringIcon from "../../../../../../assets/icons/recurring.svg";
import {
  UnderlyingContent,
  TableLabel,
  GrantSecondaryButtonComponent,
  CustomizedIcon,
  CharityTabHeading,
} from "../../style";
import { milliToDate } from "../../../../../../utils/commonUtil";
import { isGeminiUser } from "../../../../../../utils/sessionUtil";
import { addressFormat } from "../../utils";
import { removeNtee } from "../../../../../../CommonComponents/CharitySearch/utils";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";

export const tabPaneFuncton = (
  charityGranted,
  charitySaved,
  grantHistoryHandler,
  pendingCharityHandler,
  removeSavedCharity,
  scheduleHistoryHandler,
  activityBlocked = ""
) => {
  let charitySelect = [
    {
      title: "Charities recently supported",
      key: 1,
      destComponent: "table",
      mobComponent: "card",
      data: charityGranted,
      text: "No recent supported charities found",
      columnConfig: [
        {
          title: () => <CharityTabHeading>Legal Name</CharityTabHeading>,
          dataIndex: "charityName",
          key: "charityName",
          render: (value) => <TableLabel>{value} </TableLabel>,
          width: "38%",
        },
        {
          title: () => <CharityTabHeading>EIN</CharityTabHeading>,
          dataIndex: "ein",
          key: "ein",
          render: (value, record, item) => (
            <UnderlyingContent
              id={"anrEIN" + item}
              onClick={() => grantHistoryHandler(record)}
            >
              {value}
            </UnderlyingContent>
          ),
          width: "16%",
        },
        {
          title: () => <CharityTabHeading>Address</CharityTabHeading>,
          dataIndex: "location",
          key: "location",
          render: (value, record, item) => (
            <Tooltip
              placement="bottomLeft"
              title={addressFormat({
                addressLine1: record.addressLine1,
                addressLine2: record.addressLine2,
                city: record.city,
                state: record.state,
                zipCode: record.zip,
              })}
            >
              <UnderlyingContent id={"anrAddress" + item}>
                {value}
              </UnderlyingContent>
            </Tooltip>
          ),
          width: "20%",
        },
        {
          title: () => <CharityTabHeading>Last grant issued</CharityTabHeading>,
          dataIndex: "lastGrantDate",
          key: "lastGrantDate",
          render: (value) => <TableLabel>{milliToDate(value)}</TableLabel>,
          width: "17%",
        },
        {
          title: () => <CharityTabHeading>Interest Area</CharityTabHeading>,
          dataIndex: "interestArea",
          key: "interestArea",

          render: (value) => {
            if (value) {
              return <TableLabel>{removeNtee(value)} </TableLabel>;
            }
          },
          width: "17%",
        },
        {
          title: () => <div></div>,
          dataIndex: "isRecurring",
          key: "isRecurring",
          render: (value, record) => {
            return value ? (
              <div onClick={() => scheduleHistoryHandler(record)}>
                <img className="pointer" src={RecurringIcon} alt="Recurring" aria-label="recurring-icon" />
              </div>
            ) : (
              ""
            );
          },
          width: "2%",
        },
        {
          title: () => <div></div>,
          dataIndex: "isPending",
          key: "isPending",
          render: (value, record, item) => {
            return (
              <CapsuleButton
                id={"btnIsPendingSelect" + item}
                onClick={() => pendingCharityHandler(record)}
                disabled={!!activityBlocked}
                title={activityBlocked}
                text="Select"
                whiteBackground
                iconType="arrowRight"
                alt="select-charity"
              />
            );
          },
          width: "6%",
        },
      ],
    },
    {
      title: "Your saved charities",
      key: 2,
      destComponent: "table",
      mobComponent: "card",
      data: charitySaved,
      text: "No saved charities found",
      columnConfig: [
        {
          title: () => "",
          dataIndex: "savedCharity",
          key: "savedCharity",
          render: (value, record) => (
            <Tooltip placement="right" title="Remove Charity">
              <CustomizedIcon
                type="star"
                theme="filled"
                onClick={(e) => removeSavedCharity(e, record)}
              />
            </Tooltip>
          ),
          width: "1%",
        },
        {
          title: () => <CharityTabHeading>Legal Name</CharityTabHeading>,
          dataIndex: "charityName",
          key: "charityName",
          render: (value) => <TableLabel>{value} </TableLabel>,
          width: "36%",
        },
        {
          title: () => <CharityTabHeading>EIN</CharityTabHeading>,
          dataIndex: "ein",
          key: "ein",
          render: (value) => <TableLabel>{value} </TableLabel>,
          width: "17%",
        },
        {
          title: () => <CharityTabHeading>Address</CharityTabHeading>,
          dataIndex: "location",
          key: "location",
          render: (value, record, item) => (
            <Tooltip
              placement="bottomLeft"
              title={addressFormat({
                addressLine1: record.addressLine1,
                addressLine2: record.addressLine2,
                city: record.city,
                state: record.state,
                zipCode: record.zip,
              })}
            >
              <UnderlyingContent id={"anrYourSavedCharity" + item}>
                {value}
              </UnderlyingContent>
            </Tooltip>
          ),
          width: "20%",
        },
        {
          title: () => <CharityTabHeading>Interest Area</CharityTabHeading>,
          dataIndex: "interestArea",
          key: "interestArea",
          render: (value) => {
            if (value) {
              return <TableLabel>{removeNtee(value)} </TableLabel>;
            }
          },
          width: "18%",
        },
        {
          title: () => <div></div>,
          dataIndex: "isPending",
          key: "isPending",
          render: (value, record, item) => {
            return (
              <CapsuleButton
                id={"btnYourSavedCharitySelect" + item}
                onClick={() => pendingCharityHandler(record)}
                disabled={!!activityBlocked}
                title={activityBlocked}
                text="Select"
                whiteBackground
                iconType="arrowRight"
                alt = "charity select"
              />
            );
          },
          width: "7%",
        },
      ],
    },
  ];

  if (isGeminiUser()) {
    let granteeOrgStatusColumn = {
      title: () => <div>Grantee Org. Status</div>,
      dataIndex: "granteeOrgStatus",
      key: "granteeOrgStatus",
      render: (value) => <TableLabel>{value} </TableLabel>,
      className: "geminiColor",
      width: "17%",
    };
    charitySelect[0]["columnConfig"].push(granteeOrgStatusColumn);
    charitySelect[1]["columnConfig"].push(granteeOrgStatusColumn);
  }

  return charitySelect;
};
